import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import ERR from "./err.vue";
import { ref } from '@vue/reactivity'

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

// import { el } from 'element-plus/es/locale'
// const off = ref(false)
const off = ref(false)




return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_unref(off))
      ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
      : (_openBlock(), _createBlock(ERR, { key: 1 }))
  ]))
}
}

})